<template>
  <div class="mt-4 pl-5 ml-0">
    <!-- Tab Navigation -->
    <div class="d-inline-flex tabBorder">
      <div
        class="tab"
        :class="{ activeTab: activeTab === 'PROFILE' }"
        @click="activeTab = 'PROFILE'"
      >
        Profile
      </div>
      <div
        class="tab"
        :class="{ activeTab: activeTab === 'ACCOUNT' }"
        @click="activeTab = 'ACCOUNT'"
      >
        Account
      </div>
      <div
        class="tab"
        :class="{ activeTab: activeTab === 'WORK_SCHEDULE' }"
        @click="activeTab = 'WORK_SCHEDULE'"
      >
        Work Schedule
      </div>
    </div>

    <!-- Profile Tab Content -->
    <div v-if="activeTab === 'PROFILE'" class="tabContent pt-2 d-block">
      <h2 class="h2">Profile</h2>

      <div class="flex-column d-flex mb-4">
        <label class="fw-bold">Account Name</label>
        <input
          v-model="accountName"
          class="accountNameContainer"
          type="text"
          placeholder="Account name..."
        />
      </div>

      <div class="flex-column d-flex mb-4">
        <label class="fw-bold">Account URL (Web address)</label>
        <div class="d-flex align-items-center">
          <input
            v-model="accountURL"
            class="accountNameContainer"
            type="text"
            placeholder="Account name..."
          />
          <span class="ml-1">.hilo.com</span>
        </div>
      </div>

      <div class="flex-column d-flex mb-4">
        <label class="fw-bold">Account Pin</label>
        <input
          v-model="accountPin"
          class="accountNameContainer"
          type="text"
          placeholder="Create pin..."
        />
      </div>

      <div class="flex-column d-flex mb-4 posRel">
        <label class="fw-bold">Brief Company Description</label>
        <textarea
          rows="4"
          maxlength="120"
          v-model="companyDescription"
          class="accountNameTextarea"
          type="text"
          placeholder="Brief Description about your company..."
        />
        <span class="charMax" v-if="!companyDescription"
          >(120 Character Max)</span
        >
        <span class="charMax" v-else
          >{{ companyDescription.length }} / 120</span
        >
      </div>

      <div class="documentation">
        <a href="#">Documentation <img src="/img/open.svg" alt="" /></a>
      </div>

      <div class="blub mt-3 mb-3">
        <img src="/img/info-circle.svg" alt="" />
        <span
          >When you change your account’s URL, we’ll redirect from the old one
          for 30 days.</span
        >
      </div>

      <!--      SAVE FOR V2-->
      <!--      <div class="mb-4">
        <p class="font-weight-bold pb-2">Your data is stored in</p>
        <p class="d-flex align-items-center">
          The United States <img src="/img/flag__usa.png" alt="" class="ml-2" style="height: 18px;" />
        </p>
      </div>-->

      <button
        class="saveChangesWrapper"
        :disabled="isButtonDisabled"
        @click="saveFlightSchool"
      >
        Save Changes
      </button>
    </div>

    <!-- Account Tab Content -->
    <div v-if="activeTab === 'ACCOUNT'" class="tabContent pt-2 d-block">
      <h2 class="h2">Account</h2>
      <div>
        <p class="font-weight-bold pb-3">Weekends</p>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="weekends"
            id="fridayToSaturday"
            :checked="flightSchool.weekendStartFriday"
            @change="switchWeekend"
          />
          <label class="form-check-label" for="fridayToSaturday">
            Friday - Saturday
          </label>
        </div>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="weekends"
            id="saturdayToSunday"
            :checked="!flightSchool.weekendStartFriday"
            @change="switchWeekend"
          />
          <label class="form-check-label" for="saturdayToSunday">
            Saturday - Sunday
          </label>
        </div>
        <p class="small text-muted">
          This will appear across all date-related features and affect
          calculations.
        </p>
      </div>

      <div class="mt-4">
        <p class="font-weight-bold pb-3">Weekends in calendars</p>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="weekendsinCalendars"
            id="enableWeekends"
            :checked="flightSchool.weekendCalendar"
            @change="switchCalendarWeekend"
          />
          <label class="form-check-label" for="enableWeekends">
            Enable weekends in calendars
            <span class="small d-block text-muted"
              >Allow selection of weekend days and include them in
              calculations.</span
            >
          </label>
        </div>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="weekendsinCalendars"
            id="disableWeekends"
            :checked="!flightSchool.weekendCalendar"
            @change="switchCalendarWeekend"
          />
          <label class="form-check-label" for="disableWeekends">
            Disable weekends in calendars
            <span class="small d-block text-muted"
              >Block selection of weekend days and exclude them from
              calculations.</span
            >
          </label>
        </div>
        <p class="small text-muted">
          This will appear across all date-related features and affect
          calculations.
        </p>
      </div>

      <hr class="mt-4" />

      <h2 class="h2">Select Time Format</h2>

      <div class="mt-4">
        <p class="font-weight-bold pb-3">Time in calendars</p>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="timeFormat"
            id="enableStandardTime"
            :checked="flightSchool.timeFormat === '12hr'"
            @change="switchTimeFormat('12hr')"
          />
          <label class="form-check-label" for="enableStandardTime">
            Enable Standard Time
            <span class="small d-block text-muted"
              >12-hour clock with AM/PM. Example: 3:00 PM, 11:00 PM.</span
            >
          </label>
        </div>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="timeFormat"
            id="enableZuluTime"
            :checked="flightSchool.timeFormat === 'zulu'"
            @change="switchTimeFormat('zulu')"
          />
          <label class="form-check-label" for="enableZuluTime">
            Enable Zulu Time (UTC)
            <span class="small d-block text-muted"
              >Universal Coordinated Time used in aviation and military.
              Example: 1500Z (3:00 PM UTC)</span
            >
          </label>
        </div>
        <div class="form-check">
          <input
            class=""
            type="radio"
            name="timeFormat"
            id="enableMilTime"
            :checked="flightSchool.timeFormat === '24hr'"
            @change="switchTimeFormat('24hr')"
          />
          <label class="form-check-label" for="enableMilTime">
            Enable Military Time
            <span class="small d-block text-muted"
              >24-hour clock format without AM/PM. Example: 1500 (3:00 PM), 2300
              (11:00 PM)</span
            >
          </label>
        </div>
        <p class="small text-muted">
          This will be the default in your account.
        </p>

        <button class="mt-4 bg-transparent no-bg">Learn more</button>
      </div>

      <hr class="mt-4" />
    </div>

    <!-- Work Schedule Tab Content -->
    <div v-if="activeTab === 'WORK_SCHEDULE'" class="tabContent pt-2 d-block">
      <h2 class="h2">
        Work Schedule <img src="/static/img/info-circle.svg" height="25" />
      </h2>
      <br />
      <p class="d-inline small">
        Create and assign work schedules, including days off, to different
        personnel.
      </p>

      <!--      <a href="#" class="d-inline small">Learn More.</a>-->

      <!-- Add Schedule Button -->
      <button @click="openAddScheduleModal" class="d-block my-4 addButton">
        <img src="/static/img/plus_icon.svg" alt="" class="pr-2" />Add a
        Schedule
      </button>

      <div style="width: 100%">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Schedule</th>
              <th scope="col"></th>
              <th scope="col">Working Days</th>
              <th scope="col">Time</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="schedule in schedules" :key="schedule.id">
              <td style="width: 18%">{{ schedule.name }}</td>
              <td style="width: 10%">
                <span :class="schedule.enabled ? 'active' : 'inactive'">
                  {{ schedule.enabled ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                <div class="d-flex">
                  <div
                    :style="{
                      color: schedule.workSunday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Su
                  </div>
                  <div
                    :style="{
                      color: schedule.workMonday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Mo
                  </div>
                  <div
                    :style="{
                      color: schedule.workTuesday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Tu
                  </div>
                  <div
                    :style="{
                      color: schedule.workWednesday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    We
                  </div>
                  <div
                    :style="{
                      color: schedule.workThursday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Th
                  </div>
                  <div
                    :style="{
                      color: schedule.workFriday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Fr
                  </div>
                  <div
                    :style="{
                      color: schedule.workSaturday
                        ? '#404040'
                        : 'rgba(64, 64, 64, 0.5)',
                      'user-select': 'none',
                      'padding-right': '10px',
                    }"
                  >
                    Sa
                  </div>
                </div>
              </td>
              <td style="color: #3c78ff">
                <div
                  @click="editWorkSchedule(schedule)"
                  style="cursor: pointer"
                >
                  {{ $global.getTimePartOfDate(schedule.startTime) }} -
                  {{ $global.getTimePartOfDate(schedule.endTime) }}
                </div>
              </td>
              <td>
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteWorkSchedule(schedule.id)"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Modal title="Schedule Name &amp; Time" v-model="showModal">
        <div class="row" style="width: 100%">
          <div class="col-3 align-content-center">Schedule Name</div>
          <div class="col-9">
            <input
              v-model="scheduleName"
              type="text"
              class=""
              placeholder="Name..."
            />
          </div>
        </div>
        <!-- Days Selection -->
        <p class="scheduleName">Days</p>
        <div class="d-flex days-container">
          <div
            v-for="(day, index) in daysOfWeek"
            :key="index"
            class="day"
            :class="{ selected: isSelected(day) }"
            @click="toggleDaySelection(day)"
          >
            {{ day }}
          </div>
        </div>
        <!-- Time Selection -->
        <p class="scheduleName">Time</p>
        <TimeRangePicker
          v-model="time"
          style="width: 100%"
          work-or-meet="work"
        />
        <!-- Modal Save Button -->
        <button @click="confirmAddSchedule" class="btn btn-primary btn-block">
          Save
        </button>
      </Modal>

      <Modal
        :title="`Edit Time of ${editedSchedule?.name}`"
        v-model="isEditingWorkSchedule"
      >
        <div style="width: 100%" v-if="editedSchedule">
          <TimeRangePicker v-model="editedSchedule.time" work-or-meet="work" />
          <button @click="saveWorkSchedule()">Save</button>
        </div>
      </Modal>
      <!-- End Modal -->
    </div>
    <coming-soon-modal />
  </div>
</template>

<script>
import { useLoginStore } from "../../../../stores/loginStore";
import Modal from "../../Components/Modal.vue";
import WorkSchedulesAPIService from "../../../../servicehandlers/WorkSchedulesAPIService";
import TimeRangePicker from "../../Components/TimeRangePicker.vue";
import FlightSchoolsAPIService from "../../../../servicehandlers/FlightSchoolsAPIService";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

const workSchedulesAPIService = new WorkSchedulesAPIService();
const flightSchoolAPIService = new FlightSchoolsAPIService();
export default {
  components: {
    ComingSoonModal,
    TimeRangePicker,
    Modal,
  },
  data() {
    return {
      // Tab logic
      activeTab: "PROFILE",
      tabs: Object.freeze({
        PROFILE: "Profile",
        ACCOUNT: "Account",
        WORK_SCHEDULE: "Work Schedule",
      }),

      // Profile input logic
      accountName: "",
      accountURL: "",
      accountPin: "",
      companyDescription: "",
      flightSchool: null,

      // Modal & Schedule's data for Work Schedule Tab
      showModal: false,
      scheduleName: "",
      schedules: [],
      selectedDays: [],
      selectedTime: "",
      time: null,

      // Days & Times
      daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      user: null,
      isEditingWorkSchedule: false,
      editedSchedule: null,
    };
  },
  computed: {
    isButtonDisabled() {
      return (
        this.flightSchool &&
        this.accountName === this.flightSchool.name &&
        this.accountURL === this.flightSchool.url &&
        this.accountPin === this.flightSchool.pin &&
        this.companyDescription === this.flightSchool.description
      );
    },
  },
  async mounted() {
    this.user = useLoginStore().getUser;
    await this.getSchedules();
    await this.getFlightSchool();
  },
  methods: {
    getFlightSchool() {
      return flightSchoolAPIService
        .getFlightSchoolById(this.user.flightSchoolId, this.$router)
        .then((response) => {
          this.accountName = response.name;
          this.accountURL = response.url;
          this.accountPin = response.pin;
          this.companyDescription = response.description;
          this.flightSchool = response;
        });
    },
    saveFlightSchool() {
      this.flightSchool.name = this.accountName;
      this.flightSchool.url = this.accountURL;
      this.flightSchool.pin = this.accountPin;
      this.flightSchool.description = this.companyDescription;

      return flightSchoolAPIService
        .updateFlightSchool(
          this.flightSchool.id,
          this.flightSchool,
          this.$router,
        )
        .then(() => {
          this.getFlightSchool();
        });
    },
    switchWeekend() {
      this.flightSchool.weekendStartFriday =
        !this.flightSchool.weekendStartFriday;
      this.saveFlightSchool();
    },
    switchCalendarWeekend() {
      this.flightSchool.weekendCalendar = !this.flightSchool.weekendCalendar;
      this.saveFlightSchool();
    },
    switchTimeFormat(type) {
      this.flightSchool.timeFormat = type;
      this.saveFlightSchool();
    },
    getSchedules() {
      return workSchedulesAPIService
        .getAllWorkSchedulesForFlightSchool(
          this.user.flightSchoolId,
          this.$router,
        )
        .then((response) => {
          this.schedules = response;
        });
    },
    openAddScheduleModal() {
      this.showModal = true;
      this.scheduleName = "";
      this.selectedDays = [];
    },
    closeModal() {
      this.showModal = false;
    },

    // Day selection
    toggleDaySelection(day) {
      const index = this.selectedDays.indexOf(day);
      if (index === -1) {
        this.selectedDays.push(day);
      } else {
        this.selectedDays.splice(index, 1);
      }
    },
    isSelected(day) {
      return this.selectedDays.includes(day);
    },

    confirmAddSchedule() {
      let payload = {
        flightSchoolId: this.user.flightSchoolId,
        name: this.scheduleName,
        enabled: true,
        workMonday: this.selectedDays.includes("Mo"),
        workTuesday: this.selectedDays.includes("Tu"),
        workWednesday: this.selectedDays.includes("We"),
        workThursday: this.selectedDays.includes("Th"),
        workFriday: this.selectedDays.includes("Fr"),
        workSaturday: this.selectedDays.includes("Sa"),
        workSunday: this.selectedDays.includes("Su"),
        startTime: `1900-01-01 ${this.time.start}`,
        endTime: `1900-01-01 ${this.time.end}`,
      };

      return workSchedulesAPIService
        .createWorkSchedule(payload, this.$router)
        .then(() => {
          this.closeModal();
          this.getSchedules();
          this.time = null;
        });
    },

    editWorkSchedule(schedule) {
      this.editedSchedule = schedule;
      this.editedSchedule.time = {
        start: this.$global.getTimePartOfDate(schedule.startTime),
        end: this.$global.getTimePartOfDate(schedule.endTime),
      };
      this.isEditingWorkSchedule = true;
    },
    saveWorkSchedule() {
      workSchedulesAPIService
        .updateWorkSchedule(
          this.editedSchedule.id,
          {
            startTime: `1900-01-01 ${this.editedSchedule.time.start}`,
            endTime: `1900-01-01 ${this.editedSchedule.time.end}`,
          },
          this.$router,
        )
        .then(() => {
          this.getSchedules();
          this.isEditingWorkSchedule = false;
          this.editedSchedule = {
            time: null,
          };
        });
    },
    deleteWorkSchedule(id) {
      workSchedulesAPIService.deleteWorkSchedule(id, this.$router).then(() => {
        this.getSchedules();
      });
    },
  },
};
</script>

<style scoped>
.posRel {
  position: relative;
}
.charMax {
  color: #404040;
  opacity: 50%;
  font-size: 12px;
  position: absolute;
  bottom: 5px;
  left: 500px;
  transform: translate(calc(-100% - 10px), 0);
}
.scheduleName {
  color: rgba(0, 0, 0, 50%);
  font-weight: bold;
  font-size: 16px;
}
.active {
  background-color: #bdd7bc;
  border-radius: 10px;
  padding: 5px 10px;
}
.inactive {
  background-color: #d7bcbc;
  border-radius: 10px;
  padding: 5px 10px;
}
.addButton {
  border-radius: 10px;
  background-color: #3c78ff;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 15px;
  box-sizing: border-box;
  gap: 10px;
  color: #fff;
  cursor: pointer;
  user-select: none;
}
p {
  color: #404040;
  font-size: 15px;
  margin: 0;
}

.h2 {
  font-size: 35px;
  color: #404040;
  font-weight: bold;
}

/* Tab styling */
.tab:hover {
  cursor: pointer;
}

.tabBorder {
  border-bottom: 2px solid rgba(64, 64, 64, 0.25);
}

.tab {
  position: relative;
  padding: 15px 25px;
}

.tab:focus-within {
  border-bottom: 2px solid #3c78ff;
}

.tab.activeTab::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  border-bottom: 2px solid #3c78ff;
}

/* Documentation */
.documentation a {
  font-size: 12px;
  color: #3c78ff;
}

/* Notification box */
.blub {
  border-radius: 10px;
  background-color: rgba(60, 120, 255, 0.15);
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0px 15px;
  gap: 5px;
  color: #404040;
  font-size: 12px;
  max-width: fit-content;
}

/* Input fields */
.accountNameContainer {
  width: 500px;
  border-radius: 10px;
  border: 0;
  background-color: rgba(64, 64, 64, 0.05);
  height: 40px;
  padding: 0px 20px;
  color: #212529;
}
.accountNameTextarea {
  width: 500px;
  border-radius: 10px;
  border: 0;
  background-color: rgba(64, 64, 64, 0.05);
  padding: 10px 20px;
  color: #212529;
}
.accountNameTextarea::placeholder {
  color: rgba(64, 64, 64, 0.5);
}

/* Save button */
.saveChangesWrapper {
  border-radius: 10px;
  background-color: #3c78ff;
  border: 0;
  height: 40px;
  padding: 0px 20px;
  color: #fff;
  font-weight: 400;
  font-size: 15px;
}

.saveChangesWrapper:disabled {
  background-color: rgba(64, 64, 64, 0.05);
  color: rgba(64, 64, 64, 0.5);
  cursor: not-allowed;
}

/* Form check */
.form-check {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-check-label {
  text-transform: none;
}

.form-check .form-check-label {
  padding-left: 0;
  line-height: 1.5em;
  margin-bottom: 0;
  font-size: 15px;
}

.tabContent .small {
  font-size: 12px !important;
  font-family: Helvetica, Arial, sans-serif;
}

button.no-bg {
  color: #3c78ff;
  font-size: 15px;
  font-weight: 400;
  padding: 0;
}

button {
  font-weight: 400;
  font-size: 15px;
}

input[type="radio"] {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  margin-right: 8px;
  background-color: #fff;
  position: relative;
  border-radius: 50%;
  cursor: pointer;
}

input[type="radio"]:checked {
  background-color: #3c78ff;
}

input[type="radio"]:checked::before {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fff;
  position: absolute;
  top: 3px;
  left: 3px;
}

.table > thead > tr > th {
  font-size: 15px;
  text-transform: capitalize;
}

.day {
  cursor: pointer;
  user-select: none;
  color: rgba(64, 64, 64, 0.5);
}

.day.selected {
  color: #404040;
}

.days-container {
  justify-content: space-between;
  width: 100%;
}
</style>
